import SimpleList from './SimpleList'

export default SimpleList
